import gql from 'graphql-tag';
import { mutation } from 'services/graphql';
import { surfaceImageNodeFragment } from 'graphql/surface-node/fragments/surface-node-fragment/surface-image-node-fragment';
import { surfaceUnionFragment } from 'graphql/surface-node/fragments/surface-node-fragment/surface-node-union-fragment';

export const createSurfaceImageNodeMutation = gql`
  mutation createSurfaceImageNode($input: CreateSurfaceImageNodeInput!) {
    createSurfaceImageNode(input: $input) {
      data {
        ...surfaceNodeUnionDetails
      }
      error
      success
    }
  }
  ${surfaceUnionFragment}
`;

export default mutation(createSurfaceImageNodeMutation);
